export const elFaroQueNuncaSeApagaba = `En la costa de un pequeño pueblo pesquero se encontraba un faro antiguo que llevaba más de cien años guiando a los barcos durante la noche. Nadie recordaba exactamente quién lo había construido, pero todos sabían que su luz nunca se apagaba, incluso durante las tormentas más fuertes.

Don Esteban, un hombre mayor que vivía cerca del mar, era el encargado de cuidarlo. Cada tarde subía los escalones en espiral para revisar las lámparas, limpiar los cristales y asegurarse de que todo funcionara correctamente. Aunque el sistema era automático desde hacía muchos años, él seguía haciéndolo por costumbre y respeto.

Una noche, una tormenta especialmente intensa azotó la costa. El viento derribaba árboles y las olas golpeaban las rocas con furia. Muchos habitantes pensaron que el faro finalmente se apagaría, pero su luz siguió firme, atravesando la lluvia y la oscuridad.

Al día siguiente, varios pescadores fueron a agradecerle a Don Esteban, pues gracias al faro habían podido regresar sanos y salvos. Él simplemente sonrió y respondió:

—El faro no solo ilumina el mar, también nos recuerda que incluso en los momentos difíciles, siempre debe haber algo que nos guíe.`


export const preguntasFaroQueNuncaSeApaga = [
	{
		id: "pregunta1",
		pregunta: "¿Dónde se encontraba el faro de la historia?",
		opciones: ["En una ciudad grande", "En la montaña", "En la costa de un pueblo pesquero", "En medio del desierto"],
		respuesta: "En la costa de un pueblo pesquero",
	},
	{
		id: "pregunta2",
		pregunta: "¿Quién era el encargado de cuidar el faro?",
		opciones: ["Un marinero joven", "El alcalde del pueblo", "Don Esteban", "Un grupo de pescadores"],
		respuesta: "Don Esteban",
	},
	{
		id: "pregunta3",
		pregunta: "¿Qué hacía Don Esteban todas las tardes?",
		opciones: ["Pescaba", "Dormía", "Subía a revisar y limpiar el faro", "Vendía pescado"],
		respuesta: "Subía a revisar y limpiar el faro",
	},
	{
		id: "pregunta4",
		pregunta: "¿Qué ocurrió durante la tormenta fuerte?",
		opciones: ["El faro se apagó", "El faro fue destruido", "La luz del faro permaneció encendida", "No hubo tormenta"],
		respuesta: "La luz del faro permaneció encendida",
	},
	{
		id: "pregunta5",
		pregunta: "¿Qué mensaje quiso transmitir Don Esteban?",
		opciones: [
			"Que el mar es peligroso",
			"Que la tecnología lo hace todo",
			"Que siempre debe haber algo que nos guíe en momentos difíciles",
			"Que las tormentas son comunes"
		],
		respuesta: "Que siempre debe haber algo que nos guíe en momentos difíciles",
	},
];